import React, { useEffect, useState } from "react";
import GenericTable from "../../../Components/GenericTable";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, message, Tag, Space } from "antd";
import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import profile from "../../../Assests/Images/prodileDp.png";
import calendar from "../../../Assests/Images/calender.svg";
import "./style.css";
import { clientAPI, eventAPI } from "../../../utils/api";

const ClientDetail = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const location = useLocation();
  const [clientDetails, setClientDetails] = useState({});
  const [clientEvents, setClientEvents] = useState([]);
  const clientId = location.state?.clientId;

  // Load client data if editing
  useEffect(() => {
    if (clientId) {
      const loadClient = async () => {
        try {
          const response = await clientAPI.getClientDetail(clientId);
          setClientDetails({
            client: response.data.name,
            phone: response.data.phone,
            email: response.data.email,
            address: response.data.address,
          });
        } catch (error) {
          messageApi.error("Failed to load client details");
        }
      };

      const loadClientEvents = async () => {
        try {
          const response = await eventAPI.getClientEvents(clientId);
          setClientEvents(response?.results?.data);
        } catch (error) {
          messageApi.error("Failed to load client events", error);
        }
      };

      loadClient();
      loadClientEvents();
    }
  }, [clientId, messageApi]);

  const handleEdit = () => {
    navigate("/add-client", { state: { clientId: clientId } });
  };

  const columns = [
    {
      title: "Profile",
      dataIndex: "name",
      key: "profile",
      render: (_, record) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span>{record.name}</span>
          </div>
        );
      },
      enableSearch: true,
    },
    {
      title: "Event Category",
      dataIndex: "category",
      key: "category",
      filters: [
        { text: "Wedding", value: "Wedding" },
        { text: "Birthday", value: "Birthday" },
        { text: "Corporate", value: "Corporate" },
        { text: "Conference", value: "Conference" },
        { text: "Seminar", value: "Seminar" },
        { text: "Exhibition", value: "Exhibition" },
        { text: "Workshop", value: "Workshop" },
      ],
      onFilter: (value, record) => record.category === value,
    },
    {
      title: "Event Name",
      dataIndex: "name",
      key: "name",
      enableSearch: true,
    },

    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      render: (date) => (
        <span style={{ display: "flex", alignItems: "center", gap: "7.66px" }}>
          <img src={calendar} alt="Calendar" />
          {date}
        </span>
      ),
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      render: (date) => (
        <span style={{ display: "flex", alignItems: "center", gap: "7.66px" }}>
          <img src={calendar} alt="Calendar" />
          {date}
        </span>
      ),
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      title: "Event Status",
      dataIndex: "status",
      key: "status",
      filters: [
        { text: "Complete", value: "Complete" },
        { text: "Booked", value: "Booked" },
        { text: "Upcoming", value: "Upcoming" },
        { text: "Cancel", value: "Cancel" },
      ],
      onFilter: (value, record) =>
        record.status?.toLowerCase() === value.toLowerCase(),

      render: (status) => {
        const STATUS_LABELS = {
          complete: "Complete",
          booked: "Booked",
          upcoming: "Upcoming",
          cancel: "Cancel",
        };

        const key = status?.toLowerCase();

        return (
          <span className={`event-status-${key}`}>
            {STATUS_LABELS[key] || status}
          </span>
        );
      },
    },
    {
      title: "Payment",
      key: "payment",
      render: (_, record) => (
        <Space direction="vertical" size={4}>
          {!record.deposit_met && record.status !== "cancel" && (
            <Tag color="warning">Deposit Pending</Tag>
          )}
          {record.balance_due_warning && (
            <Tag color="error">Balance Due Soon</Tag>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div className="view-client">
      {contextHolder}
      <div className="back-btn">
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          className="back-btn"
        >
          Back
        </Button>
      </div>
      <div className="wrapper">
        <div className="profile-details">
          <div className="image">
            <img width={88} src={profile} alt="Profile Icon" />
          </div>

          <div className="profile-wrapper">
            <div className="info">
              <div className="name">{clientDetails?.client}</div>
              <div className="email">{clientDetails?.email}</div>
            </div>
            <div className="edit-btn">
              <Button
                type="button"
                className="edit-button"
                onClick={handleEdit}
                icon={<EditOutlined />}
              >
                Edit
              </Button>
            </div>
          </div>
        </div>
        <div className="summary-row">
          <div className="summary-item">
            <span className="label">Full Name</span>
            <span className="value">{clientDetails?.client}</span>
          </div>

          <div className="summary-item">
            <span className="label">Email Address</span>
            <span className="value">{clientDetails?.email}</span>
          </div>

          <div className="summary-item">
            <span className="label">Phone Number</span>
            <span className="value">{clientDetails?.phone}</span>
          </div>

          <div className="summary-item">
            <span className="label">City</span>
            <span className="value">Calgary, CA</span>
          </div>
          <div className="summary-item">
            <span className="label">Address</span>
            <span className="value">{clientDetails?.address}</span>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "20px" }}>
        <GenericTable
          title="All Events"
          columns={columns}
          dataSource={clientEvents}
          onRowClick={(record) => {
            navigate("/view-event-detail", { state: { eventId: record.id } });
          }}
        />
      </div>
    </div>
  );
};

export default ClientDetail;
